import styled from 'styled-components';

interface LabelProps {
    $error?: boolean;
}

export const Label = styled.label<LabelProps>`
    display: block;
    width: 100%;
    font-size: 1rem;
    color: ${(props) =>
        props.$error ? `${props.theme.error}` : props.theme.text};

    cursor: inherit;
`;

export const StrongLabel = styled.label<LabelProps>`
    display: block;
    width: 100%;
    font-family:
        'UxumGrotesque',
        var(--font-uxum),
        -apple-system,
        BlinkMacSystemFont,
        Segoe UI,
        Roboto,
        Helvetica,
        Arial,
        sans-serif;
    font-size: 1.2rem;
    font-weight: 700;
    color: ${(props) =>
        props.$error ? `${props.theme.error}` : props.theme.text};
    letter-spacing: 0;
    cursor: inherit;
`;

export const SoftLabel = styled.label<LabelProps>`
    display: block;
    width: 100%;
    font-family:
        'UxumGrotesque',
        var(--font-uxum),
        -apple-system,
        BlinkMacSystemFont,
        Segoe UI,
        Roboto,
        Helvetica,
        Arial,
        sans-serif;
    font-size: 0.9rem;
    color: ${(props) =>
        props.$error ? `${props.theme.error}` : props.theme.lightLabel};
    letter-spacing: 0;
    cursor: inherit;
`;
